import styled from 'styled-components'

export const HomeContiner = styled.div`
    margin: 24px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`